import { setComponentMapOverrides } from '@jutro/uiconfig';
import { PaymentDetailsPage } from 'gw-capability-quoteandbind-common-react';
import 'gw-capability-quoteandbind-pa-react';
import GWQuotePAPolicyDetailsPage from './pages/PolicyDetails/PolicyDetailsPage';

setComponentMapOverrides(
    {
        GWQuotePAPolicyDetailsPage: { component: 'GWQuotePAPolicyDetailsPage' },
        GWQuotePAPaymentDetailsPage: { component: 'GWQuotePAPaymentDetailsPage' }
    },
    {
        GWQuotePAPolicyDetailsPage,
        GWQuotePAPaymentDetailsPage: PaymentDetailsPage
    }
);

// eslint-disable-next-line import/prefer-default-export
export { default as PEPAWizard } from './PEPAWizard';
